import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-reservations',
  templateUrl: './itinerary-reservations.component.html',
  styleUrls: ['./itinerary-reservations.component.css']
})
export class ItineraryReservationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
